<template>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="pic">
          <div class="title">
            <div class="title-eng">VOLUNTEER OF TIME BANK</div>
            <div class="title-bold">时间银行志愿者</div>
          </div>
        </div>
        <div class="content">
          <div class="top">
            <div class="top-pic">
              <el-carousel trigger="click" height="442px">
                <el-carousel-item v-for="item in 4" :key="item">
                  <el-image
                    style="width: 100%; height: 100%; vertical-align: middle"
                    :src="require('@/assets/image/bg' + item + '.jpeg')"
                  ></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="top-int">
              <el-image
                style="width: 100%; height: 100%; vertical-align: middle"
                :src="require('@/assets/image/bg1.jpeg')"
              ></el-image>
              <div class="top-title">时间银行志愿者介绍</div>
            </div>
          </div>
          <div class="news">
            <div class="news-left">
              <div class="news-left-title">新闻活动动态</div>
              <div class="news-left-content">
                <div class="news-pic">
                  <el-image
                    style="width: 389px; height: 345px; vertical-align: middle"
                    :src="require('@/assets/image/bg2.jpeg')"
                  ></el-image>
                </div>
                <div class="news-list">
                  <div class="list" v-for="item in 5">
                    <div class="list-left">
                      跨越“数字鸿沟”，科技便利助老，志...
                    </div>
                    <div class="list-right">2021-6-25</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="news-right">
              <div class="news-right-title">志愿者活动招募</div>
              <div class="news-right-content">
                <div class="add" v-for="item in 5">
                  <div class="add-left">
                    跨越“数字鸿沟”，科技便利助老，志...
                  </div>
                  <div class="add-right">2021-6-25</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="show">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="优秀团队" name="first">
              <div class="team">
                <el-carousel
                  trigger="click"
                  :interval="0"
                  type="card"
                  height="361px"
                >
                  <el-carousel-item v-for="item in 4" :key="item">
                    <el-image
                      style="width: 100%; height: 100%; vertical-align: middle"
                      :src="require('@/assets/image/bg' + item + '.jpeg')"
                    ></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </el-tab-pane>
            <el-tab-pane label="会员风采" name="second">
              <div class="members">
                <el-carousel
                  trigger="click"
                  :interval="0"
                  type="card"
                  height="361px"
                >
                  <el-carousel-item v-for="item in 4" :key="item">
                    <el-image
                      style="width: 100%; height: 100%; vertical-align: middle"
                      :src="require('@/assets/image/bg' + item + '.jpeg')"
                    ></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";

export default {
  name: "volunteer",
  components: { headerList },
  data() {
    return {
      userInfo: {
        id: "",
        username: "7777",
        avatar: "",
      },
      username: "",
      activeName: 'first',
      showMenu: false,
      wordtop: 0,
      flag: false,
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleScroll: function () {
      if (document.body.scrollTop != 0) {
        this.wordtop = document.body.scrollTop;
      } else {
        this.wordtop = document.documentElement.scrollTop;
      }
      if (this.wordtop > 800) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    handleClick(tab, event) {
    },
    provideDetail() {
      //资讯详情
      this.$router.push("/information");
    },
  },
};
</script>

<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  margin: auto;
}

.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 115px !important;
  line-height: 115px;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}

.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
.pic {
  width: 100%;
  height: 638px;
  background: url("../assets/image/bg6.jpeg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  left: 0;
  top: 0;
}
.title {
  width: 385px;
  height: 127px;
  position: absolute;
  bottom: 0;
  right: 262px;
  background: #f77f00;
  opacity: 0.9;
  color: #fff;
}
.title-eng {
  width: 280px;
  height: 13px;
  font-size: 16px;
  font-family: Arial;
  font-weight: bold;
  color: #ffffff;
  line-height: 60px;
  margin-left: 15px;
}
.title-bold {
  width: 300px;
  height: 38px;
  font-size: 38px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 107px;
  margin-left: 15px;
}
.content {
  width: 1398px;
  height: 100%;
  margin: 50px 260px;
}
.top {
  width: 100%;
  height: 442px;
  margin: 30px auto;
}
.top-pic {
  float: left;
  height: 442px;
  width: 679px;
  background: #ccc;
}
.top-int {
  margin-left: 40px;
  float: left;
  height: 442px;
  width: 679px;
  background: #ccc;
  position: relative;
  top: 0;
  left: 0;
}
.top-title {
  position: absolute;
  top: 0;
  left: 0;
  height: 65px;
  width: 100%;
  background: #eceae3;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f77f00;
  line-height: 65px;
  text-indent: 2em;
}
.news {
  width: 100%;
  height: 443px;
  margin: 0 auto;
}
.news-left {
  width: 915px;
  height: 100%;
  float: left;
  border: 1px solid #ccc;
}
.news-left-title {
  font-size: 22px;
  height: 65px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f77f00;
  line-height: 65px;
  text-indent: 2em;
  background: #ccc;
}
.news-right {
  float: left;
  width: 440px;
  height: 100%;
  margin-left: 35px;
  border: 1px solid #ccc;
}
.news-right-title {
  font-size: 22px;
  height: 65px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f77f00;
  line-height: 65px;
  text-indent: 2em;
  background: #ccc;
}
.news-left-content {
  width: 915px;
  height: 378px;
}
.news-pic {
  width: 389px;
  height: 100%;
  margin: 16px;
  float: left;
}
.news-list {
  width: 460px;
  height: 100%;
  margin: 16px;
  float: left;
}
.list {
  width: 100%;
  height: 65px;
  line-height: 65px;
  border-bottom: 1px solid #ccc;
  color: #6d6053;
}
.list-left {
  float: left;
  width: 360px;
  height: 65px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 90px;
  text-align: center;
}
.list-right {
  float: left;
  width: 100px;
  height: 65px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 90px;
  text-align: center;
}
.list:hover {
  color: #f77f00;
}
.news-right-content {
  height: 378px;
  width: 440px;
  margin: 16px;
  float: left;
}
.add {
  height: 65px;
  line-height: 65px;
  border-bottom: 1px solid #ccc;
  color: #6d6053;
}
.add-left {
  float: left;
  width: 340px;
  height: 65px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 90px;
  text-align: center;
}
.add-right {
  float: left;
  width: 80px;
  height: 65px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 90px;
  text-align: center;
}
.add:hover {
  color: #f77f00;
}
.show {
  width: 1398px;
  height: 426px;
  margin: 30px auto;
}
.team {
  width: 100%;
  height: 361px;
}
.members{
   width: 100%;
  height: 361px;
}
</style>
